import { defineStore } from 'pinia'
import { store } from '@/store'

interface AppState {
  pageLoading: boolean
  title: string
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    pageLoading: false, // 路由跳转 loading
    title: import.meta.env.VITE_APP_TITLE // 标题
  }),
  getters: {
    getPageLoading(): boolean {
      return this.pageLoading
    },
    getTitle(): string {
      return this.title
    }
  },
  actions: {
    setPageLoading(pageLoading: boolean) {
      this.pageLoading = pageLoading
    },
    setTitle(title: string) {
      this.title = title
    }
  }
})

export const useAppStoreWithOut = () => {
  return useAppStore(store)
}
